import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import AdminLoginModal from '../../components/AdminLoginModal';

/**
 * Página de login para administrador
 * Muestra un modal para ingresar API key
 * Redirige a /admin si ya está autenticado
 */
const AdminLoginPage: React.FC = () => {
  const { isAuthenticated } = useAdminAuth();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);

  // Redirigir si ya está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin');
    }
  }, [isAuthenticated, navigate]);

  const handleCloseModal = () => {
    setShowModal(false);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <AdminLoginModal
        isOpen={showModal}
        onClose={handleCloseModal}
      />

      {/* Fallback message if modal is closed */}
      {!showModal && (
        <div className="max-w-md w-full text-center">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
            Acceso de Administrador
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Necesitas una API key válida para acceder al panel de administración.
          </p>
          <button
            onClick={() => setShowModal(true)}
            className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
          >
            Ingresar API Key
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminLoginPage;
